/* eslint-disable */

export const protobufPackage = "store.api.auth.v1";

/** RefreshRequest defines request body of method TokenService.Refresh */
export interface RefreshRequest {
  /** The refresh token's grant type, always "refresh_token". */
  grantType: string;
  /** Refresh token. Required. */
  refreshToken: string;
}

function createBaseRefreshRequest(): RefreshRequest {
  return { grantType: "", refreshToken: "" };
}

export const RefreshRequest = {
  fromJSON(object: any): RefreshRequest {
    return {
      grantType: isSet(object.grantType) ? String(object.grantType) : "",
      refreshToken: isSet(object.refreshToken) ? String(object.refreshToken) : "",
    };
  },

  toJSON(message: RefreshRequest): unknown {
    const obj: any = {};
    message.grantType !== undefined && (obj.grantType = message.grantType);
    message.refreshToken !== undefined && (obj.refreshToken = message.refreshToken);
    return obj;
  },

  create<I extends Exact<DeepPartial<RefreshRequest>, I>>(base?: I): RefreshRequest {
    return RefreshRequest.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<RefreshRequest>, I>>(object: I): RefreshRequest {
    const message = createBaseRefreshRequest();
    message.grantType = object.grantType ?? "";
    message.refreshToken = object.refreshToken ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Array<infer U> ? Array<DeepPartial<U>> : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
